import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { CloseEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsAboutApi extends ComponentAPI<any> {

  @AwesomeEvent
  onCloseModalAbout = new CloseEventListener();

}
